module.exports = __webpack_public_path__ + "img/marshal.700a57f7.gif";